module.exports = __webpack_public_path__ + "img/kraken_permissions.7845385e.png";